import Priority from "./Priority";

export default Priority;
